import * as React from 'react'

import { scrollToHash, scrollToTop } from '../../../Frontend/utils/html'
import { StyleguideConfig, StyleguidePages } from '../types'
import { styleguideVerifyAllowedSlug } from '../utils/helpers'
import { StyleguideContent } from './content'
import { StyleguideHeader } from './header'

// NOT USED YET!! 
// But should replace the legacy styleguide once the redesign project is at a good point

export const Styleguide = (page: StyleguidePages, config: StyleguideConfig) => {
  const currentPage: StyleguidePages = page || config.defaultPage

  scrollToTop()
  scrollToHash()
  return (
    <>
      {styleguideVerifyAllowedSlug(currentPage) ? (
        <article className={`styleguide styleguide--${config.company}`}>
          <div className="styleguide__main">
            <StyleguideHeader currentPage={currentPage} config={config} />
            <StyleguideContent currentPage={currentPage} config={config} />
          </div>
        </article>
      ) : (
        <></>
      )}
    </>
  )
}

// Close styleguide menu when pressing the escape key
window.addEventListener('keyup', (e) => {
  if (e.key === 'Escape') {
    document.documentElement.classList.remove('styleguide-nav--toggled')
  }
})

// Close styleguide menu when clicking outside of styleguide header/menu
document.documentElement.addEventListener('click', (e) => {
  const target: HTMLElement = (e.target as HTMLElement) || (e.currentTarget as HTMLElement)

  if (
    target.closest('.styleguide__header') === null &&
    document.documentElement.classList.contains('styleguide-nav--toggled')
  ) {
    document.documentElement.classList.remove('styleguide-nav--toggled')
  }
})
